/* eslint-disable no-console */
import { LaunchParams } from '@/features/game-context/types';
import {
  DdEventCategory,
  DdEventType,
  Logger,
} from '@/features/logging/logger';

const logFanduelError = (message: string) =>
  console.log(`%c${message}`, 'color: #e44242');

export enum NotifyErrorsNames {
  INIT_FAILED = 'FD-INIT: Launch parameters missing and failed to set game context.',
}

export const ddNotifyMissingParamsError = (payload: LaunchParams) => {
  logFanduelError(NotifyErrorsNames.INIT_FAILED);

  Logger.rumError({
    useCase: DdEventCategory.Initialization,
    eventType: DdEventType.Error,
    name: NotifyErrorsNames.INIT_FAILED,
    context: payload,
  });
};
